/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_ProjectInputs */



/**
* | output |
* | --- |
* | "New Project" |
*
* @param {New_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project = /** @type {((inputs?: New_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Projekt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый проект")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいプロジェクト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई परियोजना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo projeto")
	return /** @type {LocalizedString} */ ("New Project")
});